import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";

import analise from "./analise";
import autenticacao from "./autenticacao";
import cancelamento from "./cancelamento";
import contrato from "./contrato";
import relatorio from "./relatorio";
import venda from "./venda";
import dashboard from "./dashboard";
import usuario from "./usuario";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    ...dashboard,
    ...analise,
    ...autenticacao,
    ...cancelamento,
    ...contrato,
    ...relatorio,
    ...venda,
    ...usuario,
  ],
});

//protege a rota caso não possua um Token

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let usuario = store.getters["usuario/getUsuario"];
    if (usuario.token) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default router;
